import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2">分类浏览，精准定位你感兴趣的黑料专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${
                item.tag === '热门' ? 'bg-primary-100 text-primary-600'
                : item.tag === '重磅' ? 'bg-accent-100 text-accent-600'
                : item.tag === '新' ? 'bg-secondary-100 text-secondary-600'
                : item.tag === '日更' ? 'bg-primary-50 text-primary-500'
                : 'bg-background-100 text-foreground-500'
              }`}>
                <i className="ri-folder-line text-lg"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.tag && (
                    <span className={`px-1.5 py-0.5 text-[10px] font-semibold rounded whitespace-nowrap flex-shrink-0 ${
                      item.tag === '热门' ? 'bg-primary-100 text-primary-600'
                      : item.tag === '推荐' ? 'bg-accent-100 text-accent-600'
                      : item.tag === '重磅' ? 'bg-accent-100 text-accent-700'
                      : item.tag === '深度' ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-600'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-article-line text-xs"></i>
                  <span>{item.count} 篇内容</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}